import AWS from "aws-sdk";

const BUCKET = "daily-sarah";
const PUBLIC_BASE_URL = `https://${BUCKET}.s3.amazonaws.com`;

const S3 = new AWS.S3({
  accessKeyId: process.env.REACT_APP_S3_ACCESS_KEY_ID,
  secretAccessKey: process.env.REACT_APP_S3_SECRET_ACCESS_KEY,
  region: process.env.REACT_APP_S3_REGION,
});

export async function S3Data(prefix) {
  try {
    const params = {
      Bucket: BUCKET,
      Prefix: prefix,
    };

    return await S3.listObjectsV2(params).promise();
  } catch (error) {
    try {
      const response = await fetch(
        `${PUBLIC_BASE_URL}/?list-type=2&prefix=${encodeURIComponent(prefix)}`,
        {
          cache: "no-store",
        }
      );

      if (!response.ok) {
        return null;
      }

      const xml = await response.text();
      const parser = new DOMParser();
      const doc = parser.parseFromString(xml, "application/xml");
      const contents = Array.from(doc.getElementsByTagName("Contents")).map(
        (item) => ({
          Key: item.getElementsByTagName("Key")[0]?.textContent || "",
          ETag: item.getElementsByTagName("ETag")[0]?.textContent || "",
        })
      );

      return { Contents: contents };
    } catch (fetchError) {
      console.log(fetchError);
      return null;
    }
  }
}

export async function S3DataMain(key) {
  try {
    const params = {
      Bucket: BUCKET,
      Key: key,
    };

    return await S3.getObject(params).promise();
  } catch (error) {
    try {
      const response = await fetch(`${PUBLIC_BASE_URL}/${key}`, {
        cache: "no-store",
      });

      if (!response.ok) {
        return null;
      }

      const text = await response.text();
      return {
        Body: {
          toString: () => text,
        },
      };
    } catch (fetchError) {
      console.log(fetchError);
      return null;
    }
  }
}
